import React from "react";
import { Icon } from "../../assets/Icons.tsx";
import styles from "./CareerCard.module.scss";

interface CareerCardProps {
  downloadArrow: string;
  title: string;
  subTitle: string;
  handleShowModal: (title: string) => void; // Updated to pass title
}

const CareerCard: React.FC<CareerCardProps> = ({
  downloadArrow,
  title,
  subTitle,
  handleShowModal,
}) => {
  const handleClick = () => {
    handleShowModal(title);
  };

  return (
    <div
      className={`d-flex flex-column justify-content-start ${styles.careerCard}`}
    >
      <div>
        <p className={`heading3 fw-bold mb-0 ${styles.CareerCardTitle}`}>
          {title}
        </p>
        <div className={`${styles.dashedLine}`}></div>
      </div>

      <div className={`row ${styles.subTitleDiv}`}>
        <div className="col-10">
          <p className="para mb-0">{subTitle}</p>
        </div>

        <div
          className={`col-2 d-flex justify-content-end align-items-end ${styles.eyeIconWrapper}`}
          onClick={handleClick} 
          role="button"
        >
          <Icon name="eyeIcon" color="#036995" width="30px" height="30px" />
        </div>
      </div>
    </div>
  );
};

export default CareerCard;
